import { PhotoMeta } from './PhotoFlags';
import { v4 as uuidv4 } from 'uuid';


export class PhotoRecord
{
    public Id: string;
    public Image: Blob;
    public Meta: PhotoMeta;
    public CreatedAt: Date;

    constructor(image: Blob, meta?: Partial<PhotoMeta>)
    {
        this.Id = uuidv4();
        this.Image = image;
        this.Meta = { Selected: false, Uploaded: false, OcrText: null, ...meta };
        this.CreatedAt = new Date();
    }
}
